import { createReducer } from "typesafe-actions";

import StorageConnection from "@mapmycustomers/shared/types/resources/StorageConnection";

import {
  Actions,
  addPollingConnectionId,
  createConnection,
  deleteConnection,
  fetchConnections,
  removePollingConnectionId,
  updateConnection,
  updateConnectionInStore,
} from "./actions";

export interface ExternalResourcesState {
  connections: StorageConnection[];
  connectionsLoading: boolean;
  pollingConnectionIds: StorageConnection["id"][];
}

export const initialExternalResourcesState: ExternalResourcesState = {
  connections: [],
  connectionsLoading: false,
  pollingConnectionIds: [],
};

const externalResources = createReducer<ExternalResourcesState, Actions>(
  initialExternalResourcesState
)
  .handleAction(fetchConnections.request, (state) => ({
    ...state,
    connectionsLoading: true,
  }))
  .handleAction(fetchConnections.success, (state, { payload }) => ({
    ...state,
    connections: payload,
    connectionsLoading: false,
  }))
  .handleAction(fetchConnections.failure, (state) => ({
    ...state,
    connectionsLoading: false,
  }))
  .handleAction(createConnection.success, (state, { payload }) => ({
    ...state,
    connections: [payload, ...state.connections],
  }))
  .handleAction(updateConnection.success, (state, { payload }) => ({
    ...state,
    connections: state.connections.map((connection) =>
      connection.id === payload.id ? payload : connection
    ),
  }))
  .handleAction(deleteConnection.success, (state, { payload }) => ({
    ...state,
    connections: state.connections.filter((connection) => connection.id !== payload),
  }))
  .handleAction(updateConnectionInStore, (state, { payload }) => ({
    ...state,
    connections: state.connections.map((connection) =>
      connection.id === payload.id ? payload : connection
    ),
  }))
  .handleAction(addPollingConnectionId, (state, { payload }) => ({
    ...state,
    pollingConnectionIds: state.pollingConnectionIds.includes(payload)
      ? state.pollingConnectionIds
      : [...state.pollingConnectionIds, payload],
  }))
  .handleAction(removePollingConnectionId, (state, { payload }) => ({
    ...state,
    pollingConnectionIds: state.pollingConnectionIds.filter((id) => id !== payload),
  }));

export type ExternalResourcesActions = Actions;
export default externalResources;
